import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'

type Value = string | number | boolean | object;

type Props = {
  disabled?: boolean,
  value?: Value,
  label?: string,
  rules?: [],
  noResize?: boolean,
  loading?: boolean
  errorMessages?: string | string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TextArea',
  props: {
    disabled: { type: Boolean, default: false },
    value: { type: [String, Number, Boolean, Object], default: '' },
    label: { default: undefined },
    rules: { default: () => [] },
    noResize: { type: Boolean, default: true },
    loading: { type: Boolean },
    errorMessages: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: Value): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { disabled: boolean, value: Value, label: string, rules: [], noResize: boolean, loading?: boolean, errorMessages?: string | string[] };







const error = ref(false);

const onError = (value: boolean) => {
  error.value = value;
}

const selectedItem = computed({
  get: () => props.value,
  set: (newValue) => {
    emit("input", newValue);
  }
})

return { __sfc: true,props, emit, error, onError, selectedItem }
}

})